import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    font-size: ${(props) => props.theme.typography.size}px;
    font-family: ${(props) => props.theme.typography.fontFamily};
    background-color: ${(props) => props.theme.colors.bgDark};
  }

  *::-webkit-scrollbar {
    width: 0.75rem;
  }

  *::-webkit-scrollbar-track {
    background-color: ${(props) => props.theme.colors.b2};
    margin-bottom: 0.25rem;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.b3};
    border-radius: 1.5625rem;
  }

  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
`;

export default GlobalStyle;
